import { Tag } from "@blueprintjs/core";
import PlateImage from "../ALPR/PlateImage";
import CreditCardTag from "../UserInfo/CreditCardTag";
import SubscriberTag from "../UserInfo/SubscriberTag";
import TicketTag from "../UserInfo/TicketTag";
import { mefInterval, mefMontantStr, userColors } from "../../../utils/mef";
import i18n from "../../../i18n";
import { Trans } from "react-i18next";
import { Cell } from "@blueprintjs/table";
import BookingTag from "../UserInfo/BookingTag";

export function Col_Infosup(event) {
  const info = [];
  // TODO: que si event de BE ou BS, pour ne pas afficher sir saisie plaque en caisse automatique ou LP
  if (event.IMMAT !== undefined && event.IMMAT !== null && event.IMMAT.length > 0)
    info.push(<PlateImage key="imm" park={event.NUMEPARC} plate={event.IMMAT} date={event.DAYEVEN} device={event.NUMEEQUI} server={event["syncServerId"]}/>);

  // add a Tag relative to user type
  switch (event.TYPEUS) {
    case -1:
    case 0: // tickets
      info.push(<TicketTag
        key={"tt" + event.ID}
        id={event.ticketId}
        parkLookup={this.state.parkLookup}
        deviceLookup={this.state.deviceLookup}
        server={event["syncServerId"]}
        onOpen={event.onOpen}
        onClose={event.onClose}
      />);
      break;

    case 1: // credit card
      info.push(<CreditCardTag key={"cc" + event.ID} id={event.ccId} parkLookup={this.state.parkLookup} deviceLookup={this.state.deviceLookup} server={event["syncServerId"]} />);
      break;

    case 2://subscribers
    case 3:
      info.push(<SubscriberTag key={"st" + event.ID} id={event.subscriberId} parkLookup={this.state.parkLookup} deviceLookup={this.state.deviceLookup} server={event["syncServerId"]} />);
      break;

    case null:
    case undefined:
      break;

    case 10:
      info.push(<BookingTag key={"ut" + event.ID} id={event["IDENTIF"]} parkLookup={this.state.parkLookup} deviceLookup={this.state.deviceLookup} server={event["syncServerId"]}/> );
      break;

    default:
      info.push(
        <Tag
          icon="blank"
          key={"ut" + event.ID}
          style={
            userColors[event.TYPEUS] !== undefined
              ? { backgroundColor: userColors[event.TYPEUS] }
              : {}
          }
        >
          {i18n.t("userType" + event.TYPEUS)}
        </Tag>
      );
  }

  if (event.DURESTAT !== undefined && parseInt(event.DURESTAT) > 0) {
    info.push(
      <span key={"dur" + event.ID}>
        <Tag key="ds" icon="time">{mefInterval(event.DURESTAT*60)}</Tag>
      </span>
    );
  }

  if (event.MONTSTAT !== undefined && parseInt(event.MONTSTAT) > 0)
    info.push(
      <span key={"sp_mt" + event.ID}>
        <Tag icon="euro" key="mt">
          {mefMontantStr(event.MONTSTAT)}{" "}
          {event.MODEPAIE != null && event.MODEPAIE !== 8 ? (
            <span>
              <Trans>paid by</Trans> {i18n.t("mop" + event.MODEPAIE)}
            </span>
          ) : null}
        </Tag>
      </span>
    );

  if ([609, 611, 612].includes(event?.event?.id) && event.INFOSUP && event.INFOSUP.length > 3) // plate event
    info.push(<PlateImage key="imm" park={event.NUMEPARC} plate={event.INFOSUP} date={event.DAYEVEN} device={event.NUMEEQUI} server={event["syncServerId"]}/>);
  else if (event.INFOSUP !== null && event.INFOSUP !== undefined)
    info.push(<i key={"is" + event.ID}>{event.INFOSUP}</i>);
  
  return <Cell
    key={"isdd" + event["ID"]}
    className={event.className}>
    <span>{info}</span>
  </Cell>;
}